import React from "react";
import { ComparisonPeriod } from "@radarly/models/cards/period";
import { DatavizHorizontalBarChart } from "@radarly/models/dataviz";
import { SearchFragmentGeo, getTermFromAggs } from "@radarly/models/search";
import { useRangeFromFragment } from "../../data";
import HorizontalBarChart from "../../dataviz/horizontal-bar-chart";
import { useHorizontalBarChart } from "./model";

export interface SharedWidgetsGeoHorizontalBarChartInnerProps {
  loading: boolean;
  data: SearchFragmentGeo["data"];
  comparaisonData: SearchFragmentGeo["data"];
  fragment: SearchFragmentGeo;
  dataviz: DatavizHorizontalBarChart;
  onClickGauge?: (uid: string | number) => void;
  className?: string;
  disableAnimation?: boolean;
  comparisonPeriod: ComparisonPeriod;
  isFullscreen?: boolean;
  isPNG?: boolean;
}

export default function SharedWidgetsGeoHorizontalBarChartInner({
  loading,
  data,
  comparaisonData,
  fragment,
  className,
  dataviz,
  onClickGauge,
  disableAnimation,
  comparisonPeriod,
  isFullscreen,
  isPNG,
}: SharedWidgetsGeoHorizontalBarChartInnerProps) {
  const range = useRangeFromFragment(fragment, loading);
  const field = getTermFromAggs(fragment.request.aggs);
  const metric = fragment.request.aggs[field].metrics[0];
  const { total, gauges } = useHorizontalBarChart({
    fragment,
    dataviz,
    data,
    comparaisonData,
  });
  return (
    <HorizontalBarChart
      gauges={gauges}
      className={className}
      onClickGauge={onClickGauge}
      dataviz={dataviz}
      metric={metric}
      range={range}
      total={total}
      disableAnimation={disableAnimation}
      comparisonPeriod={comparisonPeriod}
      isFullscreen={isFullscreen}
      isPNG={isPNG}
    />
  );
}
